import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { LoadingContext, M_Table, NavigateContext } from 'src/M_Components'

export const LocationRestrictionList = ({ roles }) => {
    const { t } = useTranslation()
    const ctx = useContext(LoadingContext)
    const ctx2 = useContext(NavigateContext)

    const newRoute = (url, operation, label, row) => {
        if (operation === 'Edit' || operation === 'Copy') {
            if (row) {
                sessionStorage.setItem('editingLocationRestriction', JSON.stringify(row))
                sessionStorage.setItem('operationType', operation)
            } else {
                return
            }
        }
        if (operation === 'Create') ctx.setPassValues({ Operation: operation })
        ctx2.newTab(url, label)
    }

    return (
        <M_Table
            entityName={'LocationRestriction'}
            api='secondary'
            showTitle={true}
            title={'Location Restrictions'}
            roleName={'usersGroups'}
            rolePermissions={roles}
            replaceFunctions={new Map([
                ['Create', (row) => newRoute('containerControl/locationRestrictionCrud', 'Create', t('Add') + ' ' + t('Location') + ' ' + t('Restriction'), row)],
                ['Edit', (row) => newRoute('containerControl/locationRestrictionCrud', 'Edit', t('Edit') + ' ' + t('Location') + ' ' + t('Restriction'), row)],
                ['Copy', (row) => newRoute('containerControl/locationRestrictionCrud', 'Copy', t('Copy') + ' ' + t('Location') + ' ' + t('Restriction'), row)]
            ])}
        />
    )
}